import * as React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
export default function PrivacyPolicy() {
  return <section data-section-id="160259" id="einleitung" className="py-24 !bg-[hsl(46,97%,65%)] sm:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-[800px]">
        <div className="mb-16">
          <h1 className="text-6xl font-extrabold font-sans text-foreground tracking-tighter mb-4 border-b-4 border-primary w-fit pb-2">
            Datenschutz
          </h1>
          <p className="text-slate-700 font-sans text-lg font-medium leading-relaxed max-w-2xl">
            Sicherheit und Transparenz bilden das Fundament unserer digitalen Architektur. Wir schützen Ihre Daten mit höchster Präzision und Sorgfalt.
          </p>
        </div>

        <div className="space-y-20">
          {}
          <div className="space-y-6">
            <h2 className="text-2xl md:text-3xl font-bold font-sans text-foreground border-l-4 border-primary pl-4">
              1. Unsere Grundsätze
            </h2>
            <div className="space-y-4 font-sans text-slate-600 leading-relaxed">
              <h3 className="text-lg font-semibold text-foreground">Allgemeine Hinweise</h3>
              <p>
                Die folgenden Hinweise geben einen präzisen Überblick darüber, wie wir mit Ihren personenbezogenen Daten verfahren. Wir betrachten Datenschutz nicht nur als gesetzliche Pflicht, sondern als Qualitätsmerkmal unserer professionellen Dienstleistung.
              </p>
              <h3 className="text-lg font-semibold text-foreground mt-8">Datenerfassung und Kontrolle</h3>
              <p>
                <strong>Verantwortung in der Verarbeitung</strong><br />
                Die Datenverarbeitung auf dieser Plattform erfolgt durch den Betreiber mit modernsten Sicherheitsstandards. Details zur verantwortlichen Stelle finden Sie im folgenden Abschnitt dieser Erklärung.
              </p>
              <p>
                <strong>Methodik der Erfassung</strong><br />
                Wir erfassen Daten ausschließlich zweckgebunden. Dies geschieht entweder durch Ihre aktive Mitteilung oder durch automatisierte technische Prozesse zur Optimierung der Systemstabilität und Nutzererfahrung.
              </p>
            </div>
          </div>

          <Separator className="bg-slate-200" />

          {}
          <div className="space-y-6">
            <h2 className="text-2xl md:text-3xl font-bold font-sans text-foreground border-l-4 border-primary pl-4">
              2. Rechtliche Rahmenbedingungen
            </h2>
            <div className="space-y-4 font-sans text-slate-600 leading-relaxed">
              <h3 className="text-lg font-semibold text-foreground">Datensicherheit</h3>
              <p>
                Wir behandeln Ihre Informationen mit absoluter Vertraulichkeit. Unsere Prozesse sind strikt an den geltenden gesetzlichen Vorschriften sowie an dieser spezifischen Datenschutzerklärung ausgerichtet.
              </p>
              <p>
                In einer vernetzten Welt ist der Schutz vor unbefugtem Zugriff eine kontinuierliche Aufgabe. Wir setzen auf proaktive Sicherheitsmaßnahmen, um die Integrität Ihrer Daten über den gesamten Lebenszyklus hinweg zu gewährleisten.
              </p>
              <p>
                Trotz höchster Sicherheitsvorkehrungen weist die Datenübertragung im Internet systembedingte Risiken auf. Wir minimieren diese durch Verschlüsselung und restriktive Zugriffskontrollen.
              </p>
              
              <h3 className="text-lg font-semibold text-foreground mt-8">Hinweis zur verantwortlichen Stelle</h3>
              <p>
                Die zentrale Instanz für die Datenverarbeitung auf dieser Website ist:
              </p>
              <div className="bg-white p-6 rounded-lg border border-slate-200 shadow-sm my-4 text-foreground">
                <p className="font-bold mb-2">T&amp;M Hoch und Tiefbau</p>
                <p className="text-slate-600"><br /></p>
                <p className="text-slate-600">T&amp;M hoch &amp; Tiefbau<br />55543 Bad Kreuznach<br />Gymnasialstraße 2</p>
                <p className="mt-4 font-medium">Telefon: +49 1791505044</p>
                <p>E-Mail: Info-T&amp;Mbau@web.de</p>
              </div>
              <p>
                Verantwortlich ist die Instanz, welche über die Zwecke und Mittel der Verarbeitung von personenbezogenen Informationen im Sinne der DSGVO entscheidet.
              </p>
            </div>
          </div>

          <Separator className="bg-slate-200" />

          {}
          <div className="space-y-6">
            <h2 className="text-2xl md:text-3xl font-bold font-sans text-foreground border-l-4 border-primary pl-4">
              3. Technische Infrastruktur
            </h2>
            <div className="space-y-4 font-sans text-slate-600 leading-relaxed">
              <h3 className="text-lg font-semibold text-foreground">System-Optimierung</h3>
              <p>
                Wir nutzen technologische Hilfsmittel wie Cookies zur Bereitstellung einer reibungslosen Nutzererfahrung. Diese kleinen Datensätze ermöglichen es uns, Funktionen effizient zu steuern und die Performance der Website kontinuierlich zu skalieren.
              </p>
              <p>
                Die Rechtsgrundlage hierfür bildet <span className="font-mono text-sm bg-slate-100 px-1.5 py-0.5 rounded text-slate-900 border border-slate-200">Art. 6 Abs. 1 lit. f DSGVO</span>. Unser berechtigtes Interesse liegt in der Bereitstellung eines technisch einwandfreien und optimierten digitalen Angebots.
              </p>
              
              <h3 className="text-lg font-semibold text-foreground mt-8">Server-Protokollierung</h3>
              <p>
                Zur Gewährleistung der Systemsicherheit werden automatisch Informationen in Server-Log-Dateien protokolliert. Diese beinhalten unter anderem:
              </p>
              <ul className="list-disc pl-6 space-y-2 my-4 text-slate-700">
                <li>Spezifikationen des Browsers und Betriebssystems</li>
                <li>Referrer-Informationen zur Herkunft des Aufrufs</li>
                <li>Identifikation des zugreifenden Hostsystems</li>
                <li>Präzise Zeitstempel der Serveranfragen</li>
                <li>Anonymisierte IP-Adressen zur Fehleranalyse</li>
              </ul>
              <p>
                Diese Daten dienen ausschließlich der technischen Analyse und werden nicht mit anderen Datenquellen zusammengeführt, um eine Identifikation einzelner Personen zu vermeiden.
              </p>
              <p>
                Der Betrieb dieser Infrastruktur erfolgt auf Basis von <span className="font-mono text-sm bg-slate-100 px-1.5 py-0.5 rounded text-slate-900 border border-slate-200">Art. 6 Abs. 1 lit. f DSGVO</span> zur Sicherstellung der Betriebsbereitschaft.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-10 flex justify-center">
          <Button variant="outline" size="lg" className="border-slate-300 text-slate-900 hover:bg-slate-100 font-medium" asChild>
            <Link to="/HomePage">Zurück zur Startseite</Link>
          </Button>
        </div>
      </div>
    </section>;
}